export default __webpack_public_path__ + "static/media/capsule-trash.22f8a442.png";